import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetTreeDb } from '../redux/sheetTreeDbSlice';

const useSheetTreeDbBySheet = (sheetId: string | null) : [string, SheetTreeDb] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const id = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].sheetId === sheetId)[0];

  return [id, sheetTreeDb.sheetTrees[id]];
}

export default useSheetTreeDbBySheet;
